export interface Product {
  id: string;
  name: string;
  price: number;
  originalPrice?: number;
  category: string;
  image: string;
  rating: number;
  reviews: number;
  badge?: string;
  description: string;
}

export const products: Product[] = [
  {
    id: "1",
    name: "마스터즈 도어락 8600",
    price: 0,
    category: "도어락",
    image: "https://public.readdy.ai/ai/img_res/2ac233f0a54f659de7b176ad3342f9c6.jpg",
    rating: 4.9,
    reviews: 312,
    badge: "BEST",
    description: "지문인식 + 비밀번호 + 카드키 + 앱 제어. 마스터즈 최고급 라인업 스마트 도어락."
  },
  {
    id: "2",
    name: "마스터즈 도어락 7100",
    price: 0,
    category: "도어락",
    image: "https://readdy.ai/api/search-image?query=masters%20brand%20smart%20door%20lock%20model%207100%2C%20modern%20silver%20and%20black%20design%2C%20touchpad%20keypad%2C%20fingerprint%20sensor%2C%20clean%20white%20background%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20home%20security%20device&width=600&height=700&seq=dj2&orientation=portrait",
    rating: 4.8,
    reviews: 245,
    badge: "BEST",
    description: "지문인식 + 비밀번호 + 카드키. 합리적인 가격의 마스터즈 프리미엄 도어락."
  },
  {
    id: "3",
    name: "마스터즈 도어락 5500",
    price: 0,
    category: "도어락",
    image: "https://readdy.ai/api/search-image?query=masters%20brand%20door%20lock%20model%205500%2C%20compact%20numeric%20keypad%20design%2C%20white%20and%20silver%20finish%2C%20clean%20white%20background%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20residential%20door%20security&width=600&height=700&seq=dj3&orientation=portrait",
    rating: 4.7,
    reviews: 198,
    badge: "NEW",
    description: "번호키 + 카드키 방식. 간편하고 실용적인 마스터즈 스탠다드 도어락."
  },
  {
    id: "4",
    name: "유니코 T250",
    price: 0,
    category: "도어락",
    image: "https://readdy.ai/api/search-image?query=unico%20brand%20smart%20door%20lock%20T250%20model%2C%20slim%20modern%20design%2C%20touchscreen%20keypad%2C%20black%20finish%2C%20clean%20white%20background%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20smart%20home%20security&width=600&height=700&seq=dj4&orientation=portrait",
    rating: 4.8,
    reviews: 176,
    badge: "NEW",
    description: "슬림 터치스크린 + 지문인식. 세련된 디자인의 유니코 스마트 도어락."
  },
  {
    id: "5",
    name: "마스터즈 600N",
    price: 0,
    category: "도어락",
    image: "https://readdy.ai/api/search-image?query=masters%20brand%20door%20lock%20600N%20model%2C%20classic%20numeric%20keypad%2C%20durable%20silver%20metal%20finish%2C%20clean%20white%20background%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20apartment%20door%20security%20device&width=600&height=700&seq=dj5&orientation=portrait",
    rating: 4.6,
    reviews: 143,
    description: "번호키 전용 방식. 내구성이 뛰어난 마스터즈 베이직 도어락."
  },
  {
    id: "6",
    name: "유니코 CB100",
    price: 0,
    category: "도어락",
    image: "https://readdy.ai/api/search-image?query=unico%20brand%20door%20lock%20CB100%20model%2C%20compact%20button%20keypad%2C%20white%20clean%20design%2C%20minimalist%20style%2C%20clean%20white%20background%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20home%20entrance%20security&width=600&height=700&seq=dj6&orientation=portrait",
    rating: 4.5,
    reviews: 112,
    description: "버튼식 번호키. 심플하고 실용적인 유니코 입문형 도어락."
  },
];

export const categories = [
  {
    id: "all",
    name: "전체",
    count: 6
  },
  {
    id: "도어락",
    name: "도어락",
    count: 6,
    image: "https://readdy.ai/api/search-image?query=collection%20of%20masters%20and%20unico%20brand%20smart%20door%20locks%20on%20white%20background%2C%20various%20models%2C%20modern%20minimalist%20design%2C%20home%20security%20products%2C%20clean%20studio%20photography&width=600&height=400&seq=cat_dj1&orientation=landscape"
  },
];

export const reviews = [
  {
    id: "r1",
    name: "김지수",
    avatar: "https://readdy.ai/api/search-image?query=young%20korean%20woman%20portrait%2C%20clean%20background%2C%20natural%20smile%2C%20professional%20headshot%2C%20soft%20lighting&width=100&height=100&seq=av1&orientation=squarish",
    rating: 5,
    comment: "설치가 정말 간편하고 지문인식 속도가 엄청 빨라요! 기존 도어락이랑 비교가 안 될 정도로 편리합니다. 앱 연동도 잘 되고 가족들 모두 만족하고 있어요.",
    product: "마스터즈 도어락 8600",
    date: "2026.03.15",
    location: "서울 강남구"
  },
  {
    id: "r2",
    name: "박민준",
    avatar: "https://readdy.ai/api/search-image?query=young%20korean%20man%20portrait%2C%20clean%20background%2C%20natural%20smile%2C%20professional%20headshot%2C%20soft%20lighting&width=100&height=100&seq=av2&orientation=squarish",
    rating: 5,
    comment: "디자인이 너무 세련되고 보안도 확실해요. 외출 중에 앱으로 문 잠금 상태 확인할 수 있어서 너무 안심됩니다. 강력 추천!",
    product: "유니코 T250",
    date: "2026.03.22",
    location: "경기 성남시"
  },
  {
    id: "r3",
    name: "이서연",
    avatar: "https://readdy.ai/api/search-image?query=young%20korean%20woman%20portrait%2C%20clean%20white%20background%2C%20warm%20smile%2C%20casual%20style%2C%20soft%20natural%20lighting&width=100&height=100&seq=av3&orientation=squarish",
    rating: 5,
    comment: "도어준에서 설치해줬는데 정말 친절하고 빠르게 해주셨어요! 마스터즈 7100 너무 만족합니다.",
    product: "마스터즈 도어락 7100",
    date: "2026.04.01",
    location: "서울 마포구"
  },
  {
    id: "r4",
    name: "최현우",
    avatar: "https://readdy.ai/api/search-image?query=korean%20man%20in%2040s%20portrait%2C%20clean%20background%2C%20friendly%20smile%2C%20professional%20headshot%2C%20natural%20lighting&width=100&height=100&seq=av4&orientation=squarish",
    rating: 5,
    comment: "아파트 현관에 설치했는데 이웃들이 다 어디서 샀냐고 물어봐요. 디자인도 고급스럽고 지문인식이 정확해서 너무 편합니다.",
    product: "마스터즈 도어락 8600",
    date: "2026.03.28",
    location: "인천 연수구"
  },
  {
    id: "r5",
    name: "정유진",
    avatar: "https://readdy.ai/api/search-image?query=korean%20woman%20in%2030s%20portrait%2C%20clean%20white%20background%2C%20warm%20smile%2C%20natural%20lighting%2C%20casual%20style&width=100&height=100&seq=av5&orientation=squarish",
    rating: 4,
    comment: "혼자 사는데 보안이 걱정됐는데 이제 완전히 안심이에요. 설치 기사님도 너무 친절하셨고 사용법도 꼼꼼히 알려주셨어요.",
    product: "마스터즈 도어락 7100",
    date: "2026.04.03",
    location: "서울 송파구"
  },
  {
    id: "r6",
    name: "한동훈",
    avatar: "https://readdy.ai/api/search-image?query=korean%20man%20in%2030s%20portrait%2C%20clean%20background%2C%20confident%20smile%2C%20professional%20headshot%2C%20soft%20lighting&width=100&height=100&seq=av6&orientation=squarish",
    rating: 5,
    comment: "카드키, 지문, 번호 세 가지 방식 다 쓸 수 있어서 너무 편해요. 배터리도 오래가고 앱 알림도 바로바로 와서 만족합니다!",
    product: "유니코 T250",
    date: "2026.04.07",
    location: "경기 의정부시"
  },
];
